import {AppState} from "../store";

export const getContainerDNUStatisticsSearchPageFilter = (state: AppState) => state.containerDNUStatisticsSearchPage.filter
